import { requiredNamedObjectSchema } from './named-object.js';
import { z } from 'zod';
import { IllegalArgumentError } from 'faro-common-model';
import { uuidish } from '../utils/uuidish.js';
import { nullishToUndefined } from '../utils/nullishToUndefined.js';
export const doseFormulationSchema = z.object({
    ...requiredNamedObjectSchema.shape,
    parentId: uuidish.nullish().transform(nullishToUndefined).optional(),
    displayOnly: z.coerce.boolean(),
    description: z.string().nullish().transform(nullishToUndefined).optional(),
    synonymous: z.string().nullish().transform(nullishToUndefined).optional(),
});
export function toDoseFormulation(doseFormulation) {
    const result = doseFormulationSchema.safeParse(doseFormulation);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid DoseFormulation object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=dose-formulation.js.map